import http, { expandURI } from '@/utils/ajax'
import { RECEIPT_INIT_LOADING, RECEIPT_INIT_SUCCESS, RECEIPT_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  async receiptInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.receipt
    const expand = {}
    if (apiUrl) {
      commit(RECEIPT_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(RECEIPT_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(RECEIPT_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(RECEIPT_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  }
}
